import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const KontaktForm = lazy(() =>
  import('@/modules/kontakty/KontaktForm').then((m) => ({ default: m.KontaktForm })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kontakty/novy',
  component: () => (
    <Suspense fallback={null}>
      <KontaktForm />
    </Suspense>
  ),
});
